<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    width="420px"
    :append-to-body="appendToBody"
    @close="close"
  >
    <div
      slot="title"
      class="flex"
    >
      <i
        class="iconfont icon-tips"
        :class="[tipsInfo.icon ? tipsInfo.icon : 'icon-prompt']"
      />
      <span class="tips-title">{{ tipsInfo.title }}</span>
    </div>
    <span
      class="tips-content"
      v-html="tipsInfo.content"
    ></span>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <slot
        v-if="isHasCancelBtn"
        name="cancel"
      >
        <el-button @click="handleClose">{{ cancelText }}</el-button>
      </slot>
      <slot
        v-if="isHasConfrimBtn"
        name="confrim"
      >
        <el-button
          type="primary"
          @click="handleConfirm"
          >{{ confirmText }}</el-button
        >
      </slot>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EDialog',
  props: {
    tipsInfo: {
      type: Object,
      default: () => {}
    },
    isHasCancelBtn: {
      type: Boolean,
      default: true
    },
    isHasConfrimBtn: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    isHasCancelFun: {
      type: Boolean,
      default: false
    },
    isHasConfrimFun: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      rowData: {}
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      this.rowData = row;
    },
    close() {
      this.dialogVisible = false;
    },
    handleClose() {
      if (!this.isHasCancelFun) {
        this.close();
      } else {
        this.$emit('cancel', this.rowData);
      }
    },
    handleConfirm() {
      if (!this.isHasConfrimFun) {
        this.close();
        return;
      }
      this.$emit('confirm', this.rowData);
    }
  }
};
</script>
<style lang="less" scoped>
:deep(.el-dialog) {
  border-radius: 8px;
  .el-dialog__header,
  .el-dialog__footer {
    padding: 24px;
  }
  .el-dialog__body {
    padding: 0px 24px 0px 60px;
  }
  .el-dialog__headerbtn {
    top: 24px;
  }
  .el-button {
    height: 36px;
    padding: 0 24px;
  }
  .el-dialog__title {
    font-size: 16px;
    color: @content-color;
    font-weight: bold;
  }
  .el-dialog__close {
    color: @content-color;
    font-size: 20px;
  }
  .tips-title {
    font-size: 17px;
    font-weight: bold;
  }
  .icon-tips {
    font-size: 24px;
    margin-right: 12px;
  }
  .icon-prompt {
    color: #ff832b;
  }
  .icon-success {
    color: #00c853;
  }
  .tips-content {
    font-size: 14px;
    color: @content-color;
  }
}
</style>
